import React, { useState, useEffect, useCallback, useRef } from "react";
import { useLocation } from "react-router";
import back from "../assets/images/back_arrow.png";
import InfoIcon from "@mui/icons-material/Info"; // Import Info icon
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import "../App.css";
import camera from "../assets/images/camera.png";
import $ from "jquery";
import { BiFolderPlus, BiUpload } from "react-icons/bi";
import imageCompression from "browser-image-compression";
import pdf from "../assets/images/pdf.png";
import { Camera, CameraResultType } from "@capacitor/camera";
import { CameraSource } from "@capacitor/camera";
export default () => {
  const navigate = useNavigate();
  const [addRecordButtonHide, setAddRecordButtonHide] = useState(false);
  const [capturedImage, setCapturedImage] = useState("");
  const [scannedImage, setScannedImage] = useState("");
  const [base64ImageToFile, setBase64ImageToFile] = useState("");
  const [file_type, setFile_type] = useState("");
  const [isOpenDocumentCategory, setIsOpenDocumentCategory] = useState(false);
  const [reportsCategory, setReportsCategory] = useState("");
  const [document_name, setDocument_name] = useState("");
  const [isButtonHide, setIsButtonHide] = useState(false);
  const [backButtonHide, setBackButtonHide] = useState(false);
  const [seesionId, setSeesionId] = useState(Number);
  const [msg, setMsg] = useState("");
  const [imageURL, setImageURL] = useState(null);
  const [myFile, setMyFile] = useState("");
  const [showSelectFile, setShowSelectFile] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  let patientUniqueId = localStorage.getItem("patientUniqueId");
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); // State for modal
  console.log(patientUniqueId);
  let compressedFile;
  let url;

  let pid;

  const location = useLocation();

  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/ViewMedicalRecors", { state: { id: location.state } });
  };

  const backToRecordsHandler = () => {
    setBackButtonHide(true);
    setAddRecordButtonHide(false);
    setCapturedImage("");
    setIsOpenDocumentCategory(false);
    setShowSelectFile(false);
    setErrMsg("");
    setImageURL(null); // Reset image URL
    setMyFile(""); // Reset file
    setBase64ImageToFile(""); // Reset base64 image
    setFile_type(""); // Reset file type
    // Clear the file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input
    }
  };

  const reportsCategoryChangeHandler = (e) => {
    setReportsCategory(e.target.value);
    if (e.target.value == "Prescription") {
      setDocument_name("Prescription");
    }
  };

  const startCam = async () => {
    try {
      // Capture the photo using the Camera API
      const image = await Camera.getPhoto({
        quality: 100,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Prompt,
      });

      // Extract base64 data by removing the Data URL prefix
      let base64data = image.dataUrl.split(",")[1]; // Remove "data:image/*;base64," prefix
      setCapturedImage(image.dataUrl);

      // Create a blob from the captured image
      const blob = await fetch(image.dataUrl).then((res) => res.blob());
      console.log("Original file:", blob);

      // Compress the image if needed
      const compressedBlob = await compressImage(blob);
      const compressedUrl = URL.createObjectURL(compressedBlob);
      console.log("Compressed file:", compressedBlob);

      // If the blob was compressed, update the base64 data
      if (compressedBlob !== blob) {
        console.log("Compressed base64data: ", base64data);
        base64data = await blobToBase64(compressedBlob);
      } else {
        console.log("Original base64data: ", base64data);
      }

      // Update the state with the compressed image and its metadata
      setCapturedImage(compressedUrl);
      setFile_type("image/jpeg");
      setBase64ImageToFile(base64data); // Store the updated base64 data
      setIsOpenDocumentCategory(true);
      setAddRecordButtonHide(true);
    } catch (error) {
      console.error("Error capturing or processing the image:", error);
    }
  };

  // Utility function to compress the image
  const compressImage = async (blob) => {
    const options = {
      maxSizeMB: 0.3,
      useWebWorker: true,
    };

    // Compress only if the file size exceeds the limit
    if (blob.size > 512000) {
      return await imageCompression(blob, options);
    }
    return blob; // Return the original blob if compression is not needed
  };

  // Utility function to convert a blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // Extract base64 part
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const documentNameChangeHandler = (e) => {
    setDocument_name(e.target.value);
  };

  useEffect(() => {
    pid = localStorage.getItem("patientid");
    console.log(pid);
    setSeesionId(pid);
  }, []);
  const fileInputRef = useRef();
  const triggerUpload = () => {
    fileInputRef.current.click();
  };

  const fileChangeHandler = async (event) => {
    // Check if a file is selected
    if (!event.target.files || event.target.files.length === 0) {
      setErrMsg("No file selected.");
      return;
    }

    const file = event.target.files[0];

    // Check if the file type is valid
    if (!file.type) {
      setErrMsg("Invalid file type.");
      return;
    }

    setAddRecordButtonHide(true);
    setShowSelectFile(false);
    setErrMsg("");
    setFile_type(file.type);

    const options1 = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1000,
      useWebWorker: true,
    };

    try {
      let url;
      let base64Data = ""; // Declare the variable to hold base64 data

      if (file.type === "image/jpeg" || file.type === "image/png") {
        if (file.size > 512000) {
          const compressedFile = await imageCompression(file, options1);
          console.log("compressed file ", compressedFile);
          const newFile = new File(
            [compressedFile],
            `${compressedFile.name}.jpeg`,
            { type: "image/jpeg" }
          );
          url = URL.createObjectURL(compressedFile);

          // Convert the compressed image to base64
          const reader = new FileReader();
          reader.onloadend = () => {
            // Strip the prefix
            base64Data = reader.result.split(",")[1]; // Extract the Base64 data only
            console.log("Base64 image data: ", base64Data); // Log the base64 data here
            setMyFile(base64Data); // Set the base64 data
          };
          reader.readAsDataURL(compressedFile);
          setImageURL(url);
          setShowSelectFile(true);
          setIsOpenDocumentCategory(true);
        } else {
          url = URL.createObjectURL(file);

          // Convert the image to base64
          const reader = new FileReader();
          reader.onloadend = () => {
            // Strip the prefix
            base64Data = reader.result.split(",")[1]; // Extract the Base64 data only
            console.log("Base64 image data: ", base64Data); // Log the base64 data here
            setMyFile(base64Data); // Set the base64 data
          };
          reader.readAsDataURL(file);
          setImageURL(url);
          setShowSelectFile(true);
          setIsOpenDocumentCategory(true);
        }
      } else if (file.type === "application/pdf") {
        if (file.size > 1048576) {
          setErrMsg("Max 1MB pdf size is allowed");
        } else {
          url = URL.createObjectURL(file);

          // Convert the PDF to base64
          const reader = new FileReader();
          reader.onloadend = () => {
            // Strip the prefix
            base64Data = reader.result.split(",")[1]; // Extract the Base64 data only
            console.log("Base64 PDF data: ", base64Data); // Log the base64 data here
            setMyFile(base64Data); // Set the base64 data
          };
          reader.readAsDataURL(file);
          setImageURL(url);
          setShowSelectFile(true);
          setIsOpenDocumentCategory(true);
        }
      } else {
        setErrMsg("Unsupported file type, only .pdf, .jpg, .png files are allowed");
      }
    } catch (error) {
      console.log(error);
      setErrMsg("An error occurred while processing the file.");
    }
  };

  const uploadRecords = async (e) => {
    e.preventDefault();
    console.log("seesionId: ", seesionId);
    if (document_name != "") {
      setIsButtonHide(true);
      // let formdata = $(e.target);
      let formdata = new FormData();
      if (base64ImageToFile == "") {
        formdata.append("file", myFile);
      } else {
        formdata.append("file", base64ImageToFile);
      }
      console.log(
        "myFile: ",
        myFile,
        " base64ImageToFile: ",
        base64ImageToFile
      );
      formdata.append("patientid", patientUniqueId);
      formdata.append("flag", "M"); // M for medical records
      formdata.append('MDT', 'PM');
      formdata.append('user_role', 'rp');
      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/FileUpload/file_insert_patientapp`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log("savehandler:file upload success response:  ", data);

          if (data) {
            const filedata = new FormData();
            filedata.append("file", `${data}`);
            filedata.append("patients_id_fk", seesionId);
            filedata.append("category", reportsCategory);
            filedata.append("document_name", document_name);
            filedata.append("document_type", file_type);
            filedata.append("patients_doc_folder_id", location.state);
            filedata.append("MDT", "PM");
            filedata.append("user_role", "rp");

            $.ajax({
              type: "POST",
              url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/insert`,
              data: filedata,
              processData: false,
              contentType: false,
              success(data) {
                console.log(
                  "upload recordshandler:records upload success response:  ",
                  data
                );
                setMsg("Record added successfully");
                navigate("/ViewMedicalRecors", {
                  state: { id: location.state },
                });
                setIsButtonHide(false);
              },
              error: function (err) {
                console.log(err.responseText);
                alert(`Error has occurred: ${err.responseText}`);
              },
            });
          }
        },
        error: function (err) {
          console.log(err.responseText);
          alert(`Error has occurred: ${err.responseText}`);
        },
      });
    } else {
      e.preventDefault();
      console.log("documnt is empty");
      setErrMsg("Please select a file to proceed.");
    }
  };

  return (
    <>
      <header className="header">
        <img
          src={back}
          style={{ height: 20, width: 20 }}
          alt="back button"
          onClick={capturedImage || imageURL ? backToRecordsHandler : backHandler}
        />
        <h1 className="header-title"> Add Records</h1>
        <InfoIcon
          style={{ cursor: "pointer", marginLeft: "auto" }}
          onClick={() => setIsInfoModalOpen(true)} // Open modal on click
        />
      </header>
      <Dialog
        open={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        aria-labelledby="info-dialog-title"
        PaperProps={{
          style: {
            borderRadius: "12px", // Rounded corners
            maxWidth: "500px", // Limit modal width
            width: "90%", // Responsive width
            maxHeight: "80vh", // Limit modal height
            overflow: "hidden", // Hide overflow
          },
        }}
      >
        <DialogTitle
          id="info-dialog-title"
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            padding: "16px 24px",
            borderBottom: "1px solid #e0e0e0", // Add a subtle border
          }}
        >
          Information
        </DialogTitle>
        <DialogContent
          style={{
            padding: "16px 24px",
            overflowY: "auto", // Enable vertical scrolling
            scrollbarWidth: "none", // Hide scrollbar for Firefox
            msOverflowStyle: "none", // Hide scrollbar for IE/Edge
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px", // Add spacing between steps
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "rgb(34, 189, 250)",
                  margin: "0 0 8px 0", // Add margin for spacing
                }}
              >
                Step 1
              </p>
              <p style={{ fontSize: "16px", margin: 0 }}>
                Click on file if you have record in phone or use camera
                to take picture of the record.
              </p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "rgb(34, 189, 250)",
                  margin: "0 0 8px 0", // Add margin for spacing
                }}
              >
                Step 2
              </p>
              <p style={{ fontSize: "16px", margin: 0 }}>
                Entry for each document will be listed there, click on
                the card to view the file.
              </p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "rgb(34, 189, 250)",
                  margin: "0 0 8px 0", // Add margin for spacing
                }}
              >
                Guide
              </p>
              <p style={{ fontSize: "16px", margin: 0 }}>
                Supported file types: <strong style={{ color: "orange" }}>.jpg, .png, .pdf</strong>.
                Maximum file size allowed: <strong style={{ color: "orange" }}>Images - 500KB, PDFs - 1MB</strong>.
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0", // Add a subtle border
          }}
        >
          <Button
            onClick={() => setIsInfoModalOpen(false)}
            style={{
              textTransform: "none", // Prevent uppercase text
              fontSize: "16px",
              fontWeight: "500",
              color: "#1976d2", // Use a primary color
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <div style={{ height: "auto", width: "auto" }}>
        {msg != "" ? (
          <p
            style={{
              marginTop: 20,
              fontSize: 14,
              fontWeight: "bold",
              color: "green",
              textAlign: "center",
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            {" "}
            {msg}
          </p>
        ) : null}
        {errMsg != "" ? (
          <p
            style={{
              marginTop: 20,
              fontSize: 14,
              fontWeight: "bold",
              color: "red",
              textAlign: "center",
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            {" "}
            {errMsg}
          </p>
        ) : null}

        <div style={{ height: "65%", width: "100%" }}>
          {capturedImage != "" ? (
            <>
              <img
                name="file"
                src={capturedImage}
                style={{ marginTop: "10%", height: 280, width: "95%" }}
              />
            </>
          ) : null}
          {showSelectFile ? (
            file_type != "application/pdf" ? (
              imageURL && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: '30px',
                  }}
                >
                  <div
                    style={{
                      height: '280px', // Fixed height
                      width: '95%', // Fixed width
                      borderRadius: '10px',
                      border: '4px solid #006bff',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#f0f0f0', // Background color for empty areas
                      overflow: 'hidden',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                    }}
                  >
                    <img
                      src={imageURL}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain', // Keeps the aspect ratio
                      }}
                      alt="Displayed Image"
                    />
                  </div>
                </div>
              )
            ) : (
              <img
                src={pdf}
                style={{
                  height: 50,
                  width: 50,
                  textAlign: "left",
                  marginTop: 30,
                }}
              />
            )
          ) : null}
        </div>
        <div style={{ height: "35%", width: "100%", marginTop: 50 }}>
          {isOpenDocumentCategory == true ? (
            <div
              className="dropdown-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "left", width: "80%", }}>
                Select a document category
              </p>
              <div
                className="select-wrapper"
                style={{
                  width: "80%",
                  backgroundColor: "white",
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                <select
                  style={{ width: "80%", fontSize: 16 }}
                  name="reportsCategory"
                  value={reportsCategory}
                  onChange={(event) => reportsCategoryChangeHandler(event)}
                >
                  <option value=" "> Select</option>
                  <option value="Lab Reports"> Lab reports</option>
                  <option value="Prescription">Prescription</option>
                </select>
              </div>

              {reportsCategory === "Lab Reports" || reportsCategory === "" ? (
                <div
                  className="document-dropdown"
                  style={{
                    marginTop: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "left", width: "80%", }}>
                    Select a document name
                  </p>
                  <div
                    className="select-wrapper"
                    style={{
                      width: "80%",
                      backgroundColor: "white",
                      display: "flex",
                      marginTop: 10,
                      justifyContent: "left",
                    }}
                  >
                    <select
                      style={{ width: "80%", fontSize: 16, backgroundColor: "white" }}
                      name="document_name"
                      value={document_name}
                      onChange={(event) => documentNameChangeHandler(event)}
                    >
                      <option value=" "> Select</option>
                      <option value="Malaria Report"> Malaria Report</option>
                      <option value="Tetanus Report">Tetanus Report</option>
                      <option value="Typhoid Fever Report">
                        Typhoid Fever Report
                      </option>
                      <option value="Common Cold Report">
                        Common Cold Report
                      </option>
                      <option value="Heart Attack Report">
                        Heart Attack Report
                      </option>
                      <option value="Others Report">Others Report</option>
                    </select>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
          <div
            style={{
              position: "fixed", // Fixes the div position on the screen
              bottom: 0, // Places it at the bottom
              left: 0, // Aligns it to the left
              width: "100%", // Ensures full width
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly", // Ensures equal spacing between items
              alignItems: "center", // Aligns items vertically
              padding: "20px 0", // Adds some padding to avoid touching the edge
            }}
          >
            {/* Upload Button */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  height: 60,
                  width: 60,
                }}
                onClick={(event) => uploadRecords(event)}
                className="camera"
              >
                <BiUpload size={30} />
              </button>
              <p style={{ fontSize: 13, fontWeight: "600", marginTop: 8 }}>Upload</p>
            </div>

            {/* File Button */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <input
                className="fileinputstyle"
                type="file"
                name="mfile"
                id="mfile"
                ref={fileInputRef}
                onChange={(event) => fileChangeHandler(event)}
                style={{ display: "none" }} // Hide the default input element
              />
              <button
                style={{
                  height: 60,
                  width: 60,
                }}
                onClick={triggerUpload}
                className="camera"
              >
                <BiFolderPlus size={30} />
              </button>
              <p style={{ fontSize: 13, fontWeight: "600", marginTop: 8 }}>File</p>
            </div>

            {/* Camera Button */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div onClick={startCam} className="camera">
                <img
                  src={camera}
                  alt="camera"
                  style={{ height: 30, width: 30, marginTop: 15 }}
                />
              </div>
              <p style={{ fontSize: 13, fontWeight: "600", marginTop: 8 }}>Camera</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
